import { Typography, styled } from '@mui/material';

export const DialogContentStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.dark.dark_3,
}));
